module.exports = __webpack_public_path__ + "img/icon-ok.ff9ff5e1.svg";